import type { ReactNode } from 'react';
import { BrandWordmark } from './BrandWordmark.tsx';

interface Props {
  readonly eyebrow?: string;
  readonly title: string;
  readonly description?: string;
  readonly footer?: ReactNode;
  readonly maxWidthClassName?: string;
  readonly testId?: string;
  readonly children: ReactNode;
}

export function AuthPageFrame({
  eyebrow,
  title,
  description,
  footer,
  maxWidthClassName,
  testId,
  children,
}: Props): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-container-lowest p-6 sm:p-8">
      <div
        className={[
          'w-full rounded-[28px] bg-surface-container px-6 py-8 text-on-surface sm:px-10 sm:py-10',
          maxWidthClassName ?? 'max-w-[520px]',
        ].join(' ')}
        data-testid={testId}
      >
        <div className="mb-8 flex flex-col gap-5">
          <BrandWordmark testId="auth-brand-wordmark" />
          <div className="flex flex-col gap-3">
            {eyebrow !== undefined && eyebrow.length > 0 ? (
              <span className="inline-flex w-fit items-center rounded-full bg-surface-container-low px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-primary">
                {eyebrow}
              </span>
            ) : null}
            <div className="flex flex-col gap-2">
              <h1 className="text-3xl font-semibold tracking-tight text-on-surface">{title}</h1>
              {description !== undefined && description.length > 0 ? (
                <p className="max-w-[44ch] text-sm leading-6 text-outline">{description}</p>
              ) : null}
            </div>
          </div>
        </div>

        {children}

        {footer !== undefined ? <div className="mt-8">{footer}</div> : null}
      </div>
    </div>
  );
}
